import merge from 'deepmerge';

var m = function m() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return merge.all(styles.filter(function (s) {
    return !!s;
  }));
};

export default m;
//# sourceMappingURL=mergeCSS.js.map